import 'css-chunksrc/client/common/organizationalUnitsHierarchy/row/styles.scss';export default {
  "name": "_name_1lmvb_1",
  "selected": "_selected_1lmvb_11"
};